import { Margin_$ctor_Z207A3CFB, MarginDirection_$ctor_Z207A3CFB } from "../Types/Margin.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const MarginTop = MarginDirection_$ctor_Z207A3CFB(new Property_CssProperty(171));

export const MarginRight = MarginDirection_$ctor_Z207A3CFB(new Property_CssProperty(170));

export const MarginBottom = MarginDirection_$ctor_Z207A3CFB(new Property_CssProperty(168));

export const MarginLeft = MarginDirection_$ctor_Z207A3CFB(new Property_CssProperty(169));

export const MarginInlineStart = MarginDirection_$ctor_Z207A3CFB(new Property_CssProperty(173));

export const MarginInlineEnd = MarginDirection_$ctor_Z207A3CFB(new Property_CssProperty(174));

export const MarginBlockStart = MarginDirection_$ctor_Z207A3CFB(new Property_CssProperty(175));

export const MarginBlockEnd = MarginDirection_$ctor_Z207A3CFB(new Property_CssProperty(176));

export const Margin = Margin_$ctor_Z207A3CFB(new Property_CssProperty(172));

